/** @jsxImportSource @emotion/react */
import {
  FeedCard,
  Column,
  Text,
  TEXT_VARIANTS,
} from "../..";

export const TextCard: React.FC = () => (
  <FeedCard path="/text/id">
    <Column crossAxisAlignment="start" gap={5}>
      <Text variant={TEXT_VARIANTS.T20}>
        {
          "This subby’s dedicated to highlighting the amazing words my brilliant writer friends strung together this year. They’re all insanely talented and I owe them a lot. Here’s to another year of manic texting, rabid researching, cheetah-speed gdoc animal’ing, and lots and lots of word whittling. Enjoy the bountiful idea cornucopia below :)"
        }
      </Text>
    </Column>
  </FeedCard>
);
